import { getApiUrl } from "../utils/apiClient";
import { authFetch } from "../contexts/auth/authFetch";

export type NotificationCategoryPreferencesData = {
  preferences: {
    secondary_employment_job_alerts: { email_enabled: boolean };
    training_event_geo_alerts: { email_enabled: boolean };
    tcole_psr_availability_alerts: { email_enabled: boolean };
  };
  features: {
    secondary_employment_job_alerts: boolean;
    training_event_geo_alerts: boolean;
    tcole_psr_availability_alerts: boolean;
  };
};

export type NotificationCategoryPatchBody = {
  secondary_employment_job_alerts?: { email: boolean };
  training_event_geo_alerts?: { email: boolean };
  tcole_psr_availability_alerts?: { email: boolean };
};

export type NotificationCategoryKey = keyof NotificationCategoryPreferencesData['preferences'];

export async function getNotificationCategoryPreferences(csrfToken?: string) {
  const res = await authFetch<{ success: boolean; data: NotificationCategoryPreferencesData }>(
    getApiUrl("/api/users/me/notification-category-preferences"),
    { method: "GET", csrfToken },
  );
  if (!res.success || !res.data) {
    throw new Error(res.error || "Failed to load notification preferences");
  }
  return res.data;
}

export async function patchNotificationCategoryPreferences(
  body: NotificationCategoryPatchBody,
  csrfToken?: string,
) {
  const res = await authFetch<{
    success: boolean;
    data: Pick<NotificationCategoryPreferencesData, "preferences">;
  }>(getApiUrl("/api/users/me/notification-category-preferences"), {
    method: "PATCH",
    body: JSON.stringify(body),
    csrfToken,
  });
  if (!res.success || !res.data) {
    throw new Error(res.error || "Failed to update notification preferences");
  }
  return res.data;
}
